import { Button, Select } from "antd";
import {
  CrossIcon,
  NeedHelp,
  SelectArrow,
  TickIcon,
} from "../../../../atoms/CustomIcons";
import { useNavigate } from "react-router-dom";

export default function Header() {
  const navigate = useNavigate();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];

  return (
    <div className="profileHeader">
      <div className="headerLeft">
        <Button
          size="large"
          icon={<CrossIcon />}
          onClick={() => navigate(`/scheduling/${companyId}`)}
        />
        <h2>Work scheduler</h2>
        <Select
          style={{ width: "200px" }}
          suffixIcon={<SelectArrow />}
          menuItemSelectedIcon={<TickIcon style={{ color: "#00A07D" }} />}
          value="lm1"
          showSearch
          // allowClear
          placeholder="Contract status"
          options={[{ label: "LM 1 - Carlos E.", value: "lm1" }]}
        />
      </div>
      <div className="header_btns_wrapper">
        <Button size="large" className="btn-sm" icon={<NeedHelp />}>
          Need help?
        </Button>
        <Button size="large" className="outlined-btn">
          Discard changes
        </Button>
        <Button size="large" className="mint-btn">
          Publish schedule
        </Button>
      </div>
    </div>
  );
}
